var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "signup-nav-bar" },
    [
      _vm.signupStep === 2
        ? _c(
            "a",
            {
              staticClass: "header-link",
              attrs: { title: "Home" },
              on: { click: _vm.gotoHome },
            },
            [
              _c("img", {
                staticClass: "icon-header",
                attrs: { src: _vm.homeIcon },
              }),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.isBackButtonVisible
        ? _c(
            "primary-button",
            {
              staticClass: "btn-signup-nav",
              on: { click: _vm.handleClickBack },
            },
            [_vm._v("Back")]
          )
        : _c("a"),
      _vm._v(" "),
      _vm.shouldShowSignupNavButtons
        ? _c(
            "primary-button",
            {
              staticClass: "btn-signup-nav",
              attrs: { id: "skip-signup-step" },
              on: { click: _vm.handleClickSkip },
            },
            [_vm._v("Skip")]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("step-progress-bar", {
        staticClass: "signup-progress",
        attrs: {
          stepTitle: _vm.signupTitle,
          step: _vm.realSignupStep,
          stepCount: _vm.totalStepCount,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }